import React from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import FormikInputField from '~/components/formikInputField/formikInputField';

export const getIngredientsQuery = gql`
  query ingredients($breweryId: Int!) {
    ingredients(breweryId: $breweryId) {
      id
      name
      type
      measurementType
    }
  }
`;
const IngredientOptions = ({ brewery, ...formProps }) => (
  <Query query={getIngredientsQuery} variables={{ breweryId: brewery.id }}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <p className="mv0 i">Fetching ingredients</p>;
      }

      if (error) {
        return <p className="mv0 danger">Sorry, there was an error getting the ingredients</p>;
      }

      return (
        <FormikInputField {...formProps}>
          <option value="">Select an ingredient</option>
          {data.ingredients.map(i => (
            <option key={i.id} value={i.id}>
              {i.name}
            </option>
          ))}
        </FormikInputField>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(IngredientOptions);



// WEBPACK FOOTER //
// ./src/containers/formikIngredientOptions/formikIngredientOptions.jsx